module.exports = __webpack_public_path__ + "img/British-Embassy@2x.e9e00a07.png";